import { useState } from "react";
import { PasscodeSheet } from "./PasscodeSheet";
import { useAuth } from "../contexts/AuthContext";

export function LockScreen() {
  const { unlock } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [errorRemaining, setErrorRemaining] = useState<number | undefined>();
  const [cooldownEndsAt, setCooldownEndsAt] = useState<number | undefined>();

  const handleSubmit = async (passcode: string) => {
    setError(null);
    try {
      const r = await unlock(passcode);
      if (!r.ok) {
        setErrorRemaining(r.remaining);
        setCooldownEndsAt(r.cooldownEndsAt);
      } else {
        setErrorRemaining(undefined);
        setCooldownEndsAt(undefined);
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : "Unlock failed");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center pt-12 px-4 bg-gradient-to-b from-attic-bg to-[#f0f2f5]">
      <h1 className="text-3xl font-extrabold text-attic-accent mb-1">attic</h1>
      <p className="text-attic-dim text-xs mb-8">your knowledge, queryable</p>
      <PasscodeSheet
        title="Enter passcode"
        subtitle="attic is locked. Enter your 6-digit code to unlock."
        onSubmit={handleSubmit}
        onCancel={() => {}}
        errorMessage={error ?? undefined}
        errorRemaining={errorRemaining}
        cooldownEndsAt={cooldownEndsAt}
      />
    </div>
  );
}
